const {colors} = require(`./${window.$environment.SERVICE_PROVIDER}/variables`);

/***
 * 
 * ToolTip
 * border color - TOOLTIP_BORDER
 * background: TOOLTIP_BACKGROUND
 * text color - TOOLTIP_COLOR
 * max width - TOOLTIP_MAX_WIDTH
 * min width - TOOLTIP_MIN_WIDTH
 * font size - TOOLTIP_FONT_SIZE
 */
const overrides = {
    MuiTooltip: {
        arrow: {
          "&:before": {
            border: `1px solid ${colors?.TOOLTIP_BORDER ? colors?.TOOLTIP_BORDER : colors.PRIMARY_CONTRAST}`,
            backgroundColor: colors?.TOOLTIP_BACKGROUND ? colors?.TOOLTIP_BACKGROUND : colors.MODAL_BACKGROUND,
          },
        },
        tooltip: {
          maxWidth: colors?.TOOLTIP_MAX_WIDTH ? colors?.TOOLTIP_MAX_WIDTH : '180px',
          minWidth: colors?.TOOLTIP_MIN_WIDTH ? colors?.TOOLTIP_MIN_WIDTH : '65px',
          width: 'max-content',
          backgroundColor: colors?.TOOLTIP_BACKGROUND ? colors?.TOOLTIP_BACKGROUND : colors.MODAL_BACKGROUND,
          color: colors?.TOOLTIP_COLOR ? colors?.TOOLTIP_COLOR : colors.INPUT_COLOR,
          textAlign: 'center',
          fontSize: colors?.TOOLTIP_FONT_SIZE ? colors?.TOOLTIP_FONT_SIZE : '1rem',
          padding: '4px 8px',
          borderRadius: '2px',
          border: `solid 1px ${colors?.TOOLTIP_BORDER ? colors?.TOOLTIP_BORDER : colors.PRIMARY_CONTRAST}`,
        }
      },
};

export default overrides;